import { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import styled from 'styled-components';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { LandingLayout } from '~/atomic/layout/LandingLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { About } from '~/atomic/page/about/About';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { lessThan } from '~/lib/mediaQuery';
import { createStore, RootState } from '~/store';

const AboutPage: NextPage & LayoutType = () => {
  const title = 'О проекте | Произведения авторов полностью на Bookriver';
  const description = 'О проекте — литературно-издательская площадка Bookriver'
  + ' ⭐ Серии книг ⭐ Полные циклы произведений'
  + ' ⭐ Комментарии и отзывы читателей ⭐ Скачать произведения'
  + ' полностью в формате fb2 ✉ Найдите интересную'
  + ' книгу на нашем сайте и читайте удобно онлайн';

  return (
    <PageTemplate
      content={(
        <About />
      )}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.about.url,
      }}
      isPublic={pagesConfigStore.about.isPublic}
    />
  );
};

AboutPage.getLayout = (page) => (
  <LandingLayout headerBackground={<SCHeaderBackground />}>
    { page }
  </LandingLayout>
);

const SCHeaderBackground = styled.div`
  width: 1250px;
  height: 600px;
  position: absolute;
  user-select: none;
  pointer-events: none;
  right: 0;
  background-image: url("/image/book-header.png");
  background-size: cover;
  background-repeat: no-repeat;
  
  ${lessThan('md')} {
    background-position-y: -150px;
    left: 50%;
    transform: translateX(calc(-50% - 125px));
  }
   
  @media only screen and (max-width: 500px) {
    left: 50%;
    transform: translateX(-50%);
    
    width: 500px;
    height: 720px;
    background-size: 100%;
    background-position-y: -230px; 
    background-position-x: 0;
    background-image: url("/image/book-header-small.png");
  }
`;

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ genres: string[]; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default AboutPage;
